import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../../layouts/Header';
import useScript from '../../utils/helper/useScript';
import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';
import InstagramIcon from '@mui/icons-material/Instagram';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import Color from '../../layouts/Color';

const animatedFadeIn = {animationName: 'fadeInUp'};
const animatedNone = {animationName: 'none'};
const animatedFadeInVisible = {visibility: 'visible', animationName: 'fadeInUp'};
const logo = {fontWeight: 600, fontSize: '24px', color: Color.Main}
const logoText = {fontWeight: 600, fontSize: '24px', color: Color.Sub}

const Home = () => {
  useScript("./assets/js/jquery.min.js");
  useScript("./assets/js/jquery-ui.js");
  useScript("./assets/js/bootstrap.min.js");
  useScript("./assets/js/fontawesome.js");
  useScript("./assets/js/slick.js");
  useScript("./assets/js/jquery.nice-select.min.js");
  useScript("./assets/js/wow.min.js");
  useScript("./assets/js/plugin.js");
  useScript("./assets/js/main.js");
  
  return (
    <div>
        {/* start preloader */}
        {/* <div className="preloader" id="preloader" /> */}
        {/* end preloader */}
        {/* header-section start */}
        <Header></Header>
        {/* header-section end */}
        {/* banner-section start */}
        <section className="banner-section">
          <div className="overlay">
            <div className="banner-content d-flex align-items-center">
              <div className="container">
                <div className="row justify-content-start">
                  <div className="col-lg-7 col-md-10">
                    <div className="main-content">
                      <div className="top-area section-text justify-content-center">
                        <h4 className="sub-title">Simple. Transparent. Secure</h4>
                        <h1 className="title">Banking Solutions</h1>
                        <p className="xlr">Products and services designed to help you reach your financial goals.</p>
                      </div>
                      <div className="bottom-area">
                        <Link to="/signup" className="cmn-btn">Register</Link>
                        <Link to="/login" className="cmn-btn second scrollToContact">Get In Touch</Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="partner">
            <div className="container">
              <div className="row align-items-center">
                <div className="col-md-3 col-3">
                  <h4>Partners</h4>
                </div>
                <div className="col-md-9 col-9">
                  <div className="partner-box partner-carousel">
                    <div className="single">
                      <div className="item">
                        <img src="./assets/images/home/partner-1.png" alt="asset" />
                      </div>
                    </div>
                    <div className="single">
                      <div className="item">
                        <img src="./assets/images/home/partner-2.png" alt="asset" />
                      </div>
                    </div>
                    <div className="single">
                      <div className="item">
                        <img src="./assets/images/home/partner-3.png" alt="asset" />
                      </div>
                    </div>
                    <div className="single">
                      <div className="item">
                        <img src="./assets/images/home/partner-4.png" alt="asset" />
                      </div>
                    </div>
                    <div className="single">
                      <div className="item">
                        <img src="./assets/images/home/partner-5.png" alt="asset" />
                      </div>
                    </div>
                    <div className="single">
                      <div className="item">
                        <img src="./assets/images/home/partner-1.png" alt="asset" />
                      </div>
                    </div>
                    <div className="single">
                      <div className="item">
                        <img src="./assets/images/home/partner-2.png" alt="asset" />
                      </div>
                    </div>
                    <div className="single">
                      <div className="item">
                        <img src="./assets/images/home/partner-3.png" alt="asset" />
                      </div>
                    </div>
                    <div className="single">
                      <div className="item">
                        <img src="./assets/images/home/partner-4.png" alt="asset" />
                      </div>
                    </div>
                    <div className="single">
                      <div className="item">
                        <img src="./assets/images/home/partner-5.png" alt="asset" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* banner-section end */}
        {/* Features In start */}
        <section className="features-section">
          <div className="overlay pt-120">
            <div className="container wow fadeInUp" style={animatedFadeIn}>
              <div className="row">
                <div className="col-lg-6">
                  <div className="top-section">
                    <span className="head-icon d-flex justify-content-center align-items-center">
                      <img src="./assets/images/home/notification.png" alt="icon" />
                    </span>
                    <h5 className="sub-title">Smart Banking</h5>
                    <h2 className="title">Real time Notifications</h2>
                    <p>Your customer stays informed in real time with everything that’s happening on his account:
                      payments, transfer, advice. Get visibility on your customers' flows to anticipate their
                      needs.</p>
                    <ul className="list">
                      <li className="list-item d-flex align-items-center">
                        <span className="check d-flex align-items-center justify-content-center">
                          <img src="./assets/images/home/check.png" alt="icon" />
                        </span>
                        <span>Cards that work all across the world.</span>
                      </li>
                      <li className="list-item d-flex align-items-center ">
                        <span className="check d-flex align-items-center justify-content-center">
                          <img src="./assets/images/home/check.png" alt="icon" />
                        </span>
                        <span>No ATM fees. No minimum balance. No overdrafts.</span>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-lg-6 text-end">
                  <div className="img-area">
                    <img src="./assets/images/home/feature-item-1.png" alt="asset" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* Features In end */}
        {/* Features In start */}
        <section className="features-section second">
          <div className="overlay pt-120 pb-120">
            <div className="container wow fadeInUp" style={animatedFadeIn}>
              <div className="row">
                <div className="col-lg-6 text-start cus-ord">
                  <div className="img-area">
                    <img src="./assets/images/home/feature-item-2.png" alt="asset" />
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="top-section">
                    <span className="head-icon d-flex justify-content-center align-items-center">
                      <img src="./assets/images/home/sheled.png" alt="icon" />
                    </span>
                    <h5 className="sub-title">Safe Investments</h5>
                    <h2 className="title">The Better Way to Save &amp; Invest</h2>
                    <p>Apollo helps over 2 million customers achieve their financial goals by helping them save
                      and invest with ease. Put that extra cash to use without putting it at risk with Apollo.
                    </p>
                    <ul className="list">
                      <li className="list-item d-flex align-items-center">
                        <span className="check d-flex align-items-center justify-content-center">
                          <img src="./assets/images/home/check.png" alt="icon" />
                        </span>
                        <span>Profitable to invest and Handy to manage</span>
                      </li>
                      <li className="list-item d-flex align-items-center ">
                        <span className="check d-flex align-items-center justify-content-center">
                          <img src="./assets/images/home/check.png" alt="icon" />
                        </span>
                        <span>Highest Returns on your investments</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* Features In end */}
        {/* Solutions Business In start */}
        <section className="solutions-business">
          <div className="overlay pt-120">
            <div className="container wow fadeInUp" style={animatedNone}>
              <div className="row justify-content-center">
                <div className="col-lg-6">
                  <div className="section-header text-center">
                    <h5 className="sub-title">Open your account from anywhere in the world</h5>
                    <h2 className="title">Solutions for Every Business Need.</h2>
                    <p>Power up your business with a full-stack online bank account that fits your needs.</p>
                  </div>
                </div>
              </div>
              <div className="row cus-mar">
                <div className="col-lg-4 col-md-6">
                  <div className="single-box text-center">
                    <div className="thumb d-flex justify-content-center align-items-center">
                      <img src="./assets/images/home/checking.png" alt="checking" />
                    </div>
                    <div className="content">
                      <h5>Checking Account</h5>
                      <p>Choose from our checking options that allow you to earn interest, avoid fees, and
                        easily
                        manage your account.</p>
                      <Link to="/signup" className="btn-arrow">Log In
                        <img src="./assets/images/home/arrow-right.png" alt="arrow" />
                      </Link>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6">
                  <div className="single-box text-center">
                    <div className="thumb d-flex justify-content-center align-items-center">
                      <img src="./assets/images/home/savings.png" alt="checking" />
                    </div>
                    <div className="content">
                      <h5>Savings Accounts</h5>
                      <p>Save for your goals and watch your money grow with a CD, a money market account, a
                        savings account.Your future starts now.</p>
                      <Link to="/signup" className="btn-arrow">Start Saving
                        <img src="./assets/images/home/arrow-right.png" alt="arrow" />
                      </Link>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6">
                  <div className="single-box text-center">
                    <div className="thumb d-flex justify-content-center align-items-center">
                      <img src="./assets/images/home/business.png" alt="checking" />
                    </div>
                    <div className="content">
                      <h5>Business Account</h5>
                      <p>Take charge of your business banking with a business bank account. Services including
                        virtual cards, team management and more.</p>
                      <Link to="/signup" className="btn-arrow">Open Account
                        <img src="./assets/images/home/arrow-right.png" alt="arrow" />
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* Solutions Business In end */}
        {/* App In start */}
        <section className="features-section app-download">
          <div className="overlay pt-120">
            <div className="container wow fadeInUp" style={animatedNone}>
              <div className="row">
                <div className="col-lg-6">
                  <div className="top-section">
                    <span className="head-icon d-flex justify-content-center align-items-center">
                      <img src="./assets/images/home/sheled.png" alt="icon" />
                    </span>
                    <h5 className="sub-title">Banking at Your Fingertips</h5>
                    <h2 className="title">Your banking experience anytime, anywhere</h2>
                    <p>Get your money moving with our simple to use, accessible mobile app. As good as a bank
                      branch within your phone!</p>
                    <ul className="list">
                      <li className="list-item d-flex align-items-center">
                        <span className="check d-flex align-items-center justify-content-center">
                          <img src="./assets/images/home/check.png" alt="icon" />
                        </span>
                        <span>Bill Payments ,Funds Transfer ,QR payments</span>
                      </li>
                      <li className="list-item d-flex align-items-center ">
                        <span className="check d-flex align-items-center justify-content-center">
                          <img src="./assets/images/home/check.png" alt="icon" />
                        </span>
                        <span>Credit card payments and Order food</span>
                      </li>
                    </ul>
                  </div>
                  <div className="button-group d-flex align-items-center flex-wrap">
                    <a href="/#"><img src="./assets/images/home/google-play.png" alt="asset" /></a>
                    <a href="/#"><img src="./assets/images/home/app-store.png" alt="asset" /></a>
                  </div>
                </div>
                <div className="col-lg-6 text-end">
                  <div className="img-area">
                    <img className="max-un" src="./assets/images/home/apps.png" alt="asset" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* App In end */}
        {/* Card In start */}
        <section className="card-section">
          <div className="overlay pt-120 pb-120">
            <div className="container wow fadeInUp" style={animatedNone}>
              <div className="row justify-content-end">
                <div className="col-lg-6">
                  <div className="section-header">
                    <h5 className="sub-title">Boost your savings with the right credit card</h5>
                    <h2 className="title">Access Endless Possibilities with Apollo Card</h2>
                    <p>All your needs covered with a full range of credit and prepaid cards.</p>
                  </div>
                </div>
              </div>
              <div className="row d-flex justify-content-end">
                <div className="col-lg-5">
                  <div className="pb-120">
                    <div className="card-carousel-index">
                      <div className="single">
                        <div className="thumb">
                          <img src="./assets/images/home/card-img-1.png" alt="asset" />
                        </div>
                        <div className="button-area text-center">
                          <Link to="/signup" className="cmn-btn" tabIndex={-1}>Get Started Now</Link>
                        </div>
                      </div>
                      <div className="single">
                        <div className="thumb">
                          <img src="./assets/images/home/card-img-2.png" alt="asset" />
                        </div>
                        <div className="button-area text-center">
                          <Link to="/signup" className="cmn-btn" tabIndex={-1}>Get Started Now</Link>
                        </div>
                      </div>
                      <div className="single">
                        <div className="thumb">
                          <img src="./assets/images/home/card-img-1.png" alt="asset" />
                        </div>
                        <div className="button-area text-center">
                          <Link to="/signup" className="cmn-btn" tabIndex={-1}>Get Started Now</Link>
                        </div>
                      </div>
                      <div className="single">
                        <div className="thumb">
                          <img src="./assets/images/home/card-img-2.png" alt="asset" />
                        </div>
                        <div className="button-area text-center">
                          <Link to="/signup" className="cmn-btn" tabIndex={-1}>Get Started Now</Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6">
                  <ul className="nav nav-tabs" role="tablist">
                    <li className="nav-item" role="presentation">
                      <button className="nav-link active" id="credit-tab" data-bs-toggle="tab" data-bs-target="#credit" type="button" role="tab" aria-controls="credit" aria-selected="true">Credit Card</button>
                    </li>
                    <li className="nav-item" role="presentation">
                      <button className="nav-link" id="debit-tab" data-bs-toggle="tab" data-bs-target="#debit" type="button" role="tab" aria-controls="debit" aria-selected="false">Prepaid
                        Card</button>
                    </li>
                  </ul>
                  <div className="tab-content">
                    <div className="tab-pane fade show active" id="credit" role="tabpanel" aria-labelledby="credit-tab">
                      <div className="row cus-mar">
                        <div className="col-md-6">
                          <div className="single-box text-center">
                            <div className="thumb">
                              <img src="./assets/images/home/tab-card-1.png" alt="icon" className="active" />
                              <img src="./assets/images/home/tab-card-11.png" alt="icon" className="alt" />
                            </div>
                            <a href="/#">
                              <h5>Secured Cards</h5>
                            </a>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="single-box text-center">
                            <div className="thumb">
                              <img src="./assets/images/home/tab-card-2.png" alt="icon" className="active" />
                              <img src="./assets/images/home/tab-card-22.png" alt="icon" className="alt" />
                            </div>
                            <a href="/#">
                              <h5>Balance Transfer</h5>
                            </a>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="single-box text-center">
                            <div className="thumb">
                              <img src="./assets/images/home/tab-card-3.png" alt="icon" className="active" />
                              <img src="./assets/images/home/tab-card-33.png" alt="icon" className="alt" />
                            </div>
                            <a href="/#">
                              <h5>Travel</h5>
                            </a>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="single-box text-center">
                            <div className="thumb">
                              <img src="./assets/images/home/tab-card-4.png" alt="icon" className="active" />
                              <img src="./assets/images/home/tab-card-44.png" alt="icon" className="alt" />
                            </div>
                            <a href="/#">
                              <h5>Cashback</h5>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="tab-pane fade" id="debit" role="tabpanel" aria-labelledby="debit-tab">
                      <div className="row cus-mar">
                        <div className="col-md-6">
                          <div className="single-box text-center">
                            <div className="thumb">
                              <img src="./assets/images/home/tab-card-1.png" alt="icon" className="active" />
                              <img src="./assets/images/home/tab-card-11.png" alt="icon" className="alt" />
                            </div>
                            <a href="/#">
                              <h5>Secured Cards</h5>
                            </a>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="single-box text-center">
                            <div className="thumb">
                              <img src="./assets/images/home/tab-card-2.png" alt="icon" className="active" />
                              <img src="./assets/images/home/tab-card-22.png" alt="icon" className="alt" />
                            </div>
                            <a href="/#">
                              <h5>Balance Transfer</h5>
                            </a>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="single-box text-center">
                            <div className="thumb">
                              <img src="./assets/images/home/tab-card-3.png" alt="icon" className="active" />
                              <img src="./assets/images/home/tab-card-33.png" alt="icon" className="alt" />
                            </div>
                            <a href="/#">
                              <h5>Travel</h5>
                            </a>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="single-box text-center">
                            <div className="thumb">
                              <img src="./assets/images/home/tab-card-4.png" alt="icon" className="active" />
                              <img src="./assets/images/home/tab-card-44.png" alt="icon" className="alt" />
                            </div>
                            <a href="/#">
                              <h5>Cashback</h5>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* Card In end */}
        {/* Call to action In start */}
        <section className="call-action">
          <div className="overlay pt-120">
            <div className="container wow fadeInUp" style={animatedNone}>
              <div className="row d-flex justify-content-center">
                <div className="col-lg-10">
                  <div className="main-content">
                    <div className="section-header text-center">
                      <h2 className="title"><span>Ready to make the leap?</span>Let us help you.</h2>
                    </div>
                    <div className="bottom-area text-center">
                      <Link to="/signup" className="cmn-btn">Open Account</Link>
                      <a href="/#" className="cmn-btn second scrollToContact">Get In Touch</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* Call to action In end */}
        {/* Financial Planning In start */}
        <section className="financial-planning">
          <div className="overlay pt-120 pb-120">
            <div className="container wow fadeInUp" style={animatedNone}>
              <div className="row d-flex justify-content-center">
                <div className="col-xl-6 col-lg-5">
                  <div className="section-text">
                    <h5 className="sub-title">Financial Planning</h5>
                    <h2 className="title">Let's plan your finances the right way</h2>
                    <p>Lending that doesn't weigh you down.We know how hard is it to start something new, that’s
                      why we have the perfect plan for you.</p>
                  </div>
                  <Link to="/signup" className="cmn-btn">Apply for a loan</Link>
                </div>
                <div className="col-xl-6 col-lg-7">
                  <div className="row cus-mar">
                    <div className="col-md-6 col-sm-6">
                      <div className="plan-box">
                        <div className="thumb">
                          <img src="./assets/images/home/loan-1.png" alt="icon" className="active" />
                          <img src="./assets/images/home/loan-11.png" alt="icon" className="alt" />
                        </div>
                        <a href="/#">
                          <h5>Home Loans</h5>
                        </a>
                        <ul className="list">
                          <li className="list-item d-flex align-items-center">
                            <span className="check d-flex align-items-center justify-content-center">
                              <img src="./assets/images/home/check.png" alt="icon" />
                            </span>
                            <span>Lowest interest rates</span>
                          </li>
                          <li className="list-item d-flex align-items-center">
                            <span className="check d-flex align-items-center justify-content-center">
                              <img src="./assets/images/home/check.png" alt="icon" />
                            </span>
                            <span>Fast Loan Processing</span>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className="col-md-6 col-sm-6">
                      <div className="plan-box">
                        <div className="thumb">
                          <img src="./assets/images/home/loan-2.png" alt="icon" className="active" />
                          <img src="./assets/images/home/loan-22.png" alt="icon" className="alt" />
                        </div>
                        <a href="/#">
                          <h5>Car Loans</h5>
                        </a>
                        <ul className="list">
                          <li className="list-item d-flex align-items-center">
                            <span className="check d-flex align-items-center justify-content-center">
                              <img src="./assets/images/home/check.png" alt="icon" />
                            </span>
                            <span>Competitive rates</span>
                          </li>
                          <li className="list-item d-flex align-items-center">
                            <span className="check d-flex align-items-center justify-content-center">
                              <img src="./assets/images/home/check.png" alt="icon" />
                            </span>
                            <span>Quick Easy</span>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className="col-md-6 col-sm-6">
                      <div className="plan-box">
                        <div className="thumb">
                          <img src="./assets/images/home/loan-3.png" alt="icon" className="active" />
                          <img src="./assets/images/home/loan-33.png" alt="icon" className="alt" />
                        </div>
                        <a href="/#">
                          <h5>Education Loans</h5>
                        </a>
                        <ul className="list">
                          <li className="list-item d-flex align-items-center">
                            <span className="check d-flex align-items-center justify-content-center">
                              <img src="./assets/images/home/check.png" alt="icon" />
                            </span>
                            <span>Pay back conveniently</span>
                          </li>
                          <li className="list-item d-flex align-items-center">
                            <span className="check d-flex align-items-center justify-content-center">
                              <img src="./assets/images/home/check.png" alt="icon" />
                            </span>
                            <span>Fast Loan Processing</span>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className="col-md-6 col-sm-6">
                      <div className="plan-box">
                        <div className="thumb">
                          <img src="./assets/images/home/loan-4.png" alt="icon" className="active" />
                          <img src="./assets/images/home/loan-44.png" alt="icon" className="alt" />
                        </div>
                        <a href="/#">
                          <h5>Business Loans</h5>
                        </a>
                        <ul className="list">
                          <li className="list-item d-flex align-items-center">
                            <span className="check d-flex align-items-center justify-content-center">
                              <img src="./assets/images/home/check.png" alt="icon" />
                            </span>
                            <span>Easy Approvals</span>
                          </li>
                          <li className="list-item d-flex align-items-center">
                            <span className="check d-flex align-items-center justify-content-center">
                              <img src="./assets/images/home/check.png" alt="icon" />
                            </span>
                            <span>Full Assistance</span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* Financial Planning In end */}
        {/* Personalized In start */}
        <section className="personalized">
          <div className="overlay">
            <div className="container wow fadeInUp" style={animatedNone}>
              <div className="row d-flex justify-content-between">
                <div className="col-lg-6 col-xl-5 d-flex align-items-center justify-content-end">
                  <div className="img-area">
                    <img src="./assets/images/home/personalized.png" alt="asset" />
                  </div>
                </div>
                <div className="col-lg-6 col-xl-5 pt-120 pb-120">
                  <div className="section-text">
                    <h3 className="title">Need a Personalized Solution?</h3>
                    <p>Get in touch with us, and we will help you to create the right one for your business or
                      personal needs.</p>
                  </div>
                  <Link to="/signup" className="cmn-btn">Apply for a loan</Link>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* Personalized In end */}
        <section className="apply-for-loan contact" id="contact">
          <div className="overlay pt-120 pb-120">
            <div className="container wow fadeInUp" style={animatedFadeInVisible}>
              <div className="row justify-content-center">
                <div className="col-lg-8">
                  <div className="section-header text-center">
                    <h2 className="title">Get in touch with us.</h2>
                    <p>Fill up the form and our team will get back to you within 24 hours</p>
                  </div>
                </div>
              </div>
              <div className="row justify-content-center">
                <div className="col-lg-10">
                  <div className="form-content">
                    <form action="#">
                      <div className="row">
                        <div className="col-6">
                          <div className="single-input">
                            <label htmlFor="name">Name</label>
                            <input type="text" id="name" placeholder="What's your name?" />
                          </div>
                        </div>
                        <div className="col-6">
                          <div className="single-input">
                            <label htmlFor="email">Email</label>
                            <input type="text" id="email" placeholder="What's your email?" />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-6">
                          <div className="single-input">
                            <label htmlFor="phone">Phone</label>
                            <input type="text" id="phone" placeholder="(123) 480 - 3540" />
                          </div>
                        </div>
                        <div className="col-6">
                          <div className="single-input">
                            <label htmlFor="loan">Service interested in</label>
                            <input type="text" id="loan" placeholder="Ex. Auto Loan, Home Loan" />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-12">
                          <div className="single-input">
                            <label htmlFor="message">Message</label>
                            <textarea id="message" placeholder="I would like to get in touch with you..." cols={30} rows={10} defaultValue={""} />
                          </div>
                        </div>
                      </div>
                      <div className="btn-area text-center">
                        <button className="cmn-btn">Send Message</button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* FAQs In start */}
        <section className="faqs-section">
          <div className="overlay pt-120 pb-120">
            <div className="container wow fadeInUp" style={animatedNone}>
              <div className="row d-flex justify-content-center">
                <div className="col-lg-6">
                  <div className="section-header text-center">
                    <h5 className="sub-title">If you have question,we have answer</h5>
                    <h2 className="title">Frequently asked questions</h2>
                    <p>Get answers to all questions you have and boost your knowledge so you can save, invest
                      and spend smarter. <a href="faqs.html">See all questions here!</a></p>
                  </div>
                </div>
              </div>
              <div className="row d-flex justify-content-center">
                <div className="col-xl-8">
                  <div className="faq-box wow fadeInUp" style={animatedNone}>
                    <div className="accordion" id="accordionExample">
                      <div className="accordion-item">
                        <h5 className="accordion-header" id="headingTwo">
                          <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                            How do I locate the nearesty branch or ATM?
                          </button>
                        </h5>
                        <div id="collapseTwo" className="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
                          <div className="accordion-body">
                            <p>If your card is missing, let us know immediately. We’ll block your card
                              right away send over a new one on the same day.To report a lost or
                              stolen card, call us at (406) 555-0120.</p>
                          </div>
                        </div>
                      </div>
                      <div className="accordion-item">
                        <h5 className="accordion-header" id="headingThree">
                          <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                            What do I do if I lose my card or it gets stolen?
                          </button>
                        </h5>
                        <div id="collapseThree" className="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#accordionExample">
                          <div className="accordion-body">
                            <p>If your card is missing, let us know immediately. We’ll block your card
                              right away send over a new one on the same day.To report a lost or
                              stolen card, call us at (406) 555-0120.</p>
                          </div>
                        </div>
                      </div>
                      <div className="accordion-item">
                        <h5 className="accordion-header" id="headingFour">
                          <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                            What is your customer service number?
                          </button>
                        </h5>
                        <div id="collapseFour" className="accordion-collapse collapse" aria-labelledby="headingFour" data-bs-parent="#accordionExample">
                          <div className="accordion-body">
                            <p>If your card is missing, let us know immediately. We’ll block your card
                              right away send over a new one on the same day.To report a lost or
                              stolen card, call us at (406) 555-0120.</p>
                          </div>
                        </div>
                      </div>
                      <div className="accordion-item">
                        <h5 className="accordion-header" id="headingFive">
                          <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
                            How do I reset my pin?
                          </button>
                        </h5>
                        <div id="collapseFive" className="accordion-collapse collapse" aria-labelledby="headingFive" data-bs-parent="#accordionExample">
                          <div className="accordion-body">
                            <p>If your card is missing, let us know immediately. We’ll block your card
                              right away send over a new one on the same day.To report a lost or
                              stolen card, call us at (406) 555-0120.</p>
                          </div>
                        </div>
                      </div>
                      <div className="accordion-item">
                        <h5 className="accordion-header" id="headingsix">
                          <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapsesix" aria-expanded="false" aria-controls="collapsesix">
                            What is required to use Digital Banking?
                          </button>
                        </h5>
                        <div id="collapsesix" className="accordion-collapse collapse" aria-labelledby="headingsix" data-bs-parent="#accordionExample">
                          <div className="accordion-body">
                            <p>If your card is missing, let us know immediately. We’ll block your card
                              right away send over a new one on the same day.To report a lost or
                              stolen card, call us at (406) 555-0120.</p>
                          </div>
                        </div>
                      </div>
                      <div className="accordion-item">
                        <h5 className="accordion-header" id="headingsaven">
                          <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapsesaven" aria-expanded="false" aria-controls="collapsesaven">
                            Is digital banking secure?
                          </button>
                        </h5>
                        <div id="collapsesaven" className="accordion-collapse collapse" aria-labelledby="headingsaven" data-bs-parent="#accordionExample">
                          <div className="accordion-body">
                            <p>If your card is missing, let us know immediately. We’ll block your card
                              right away send over a new one on the same day.To report a lost or
                              stolen card, call us at (406) 555-0120.</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* FAQs In end */}
        {/* Get Start In start */}
        <section className="get-start wow fadeInUp" style={animatedNone}>
          <div className="overlay">
            <div className="container">
              <div className="col-12">
                <div className="get-content">
                  <div className="section-text">
                    <h3 className="title">Ready to get started?</h3>
                    <p>It only takes a few minutes to register your FREE Apollo account.</p>
                  </div>
                  <Link to="/signup" className="cmn-btn">Open an account</Link>
                  <img src="./assets/images/home/get-start.png" alt="images" />
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* Get Start In end */}
        {/* Footer Area Start */}
        <div className="footer-section">
          <div className="container pt-120">
            <div className="row cus-mar pt-120 pb-120 justify-content-between wow fadeInUp" style={animatedNone}>
              <div className="col-xl-3 col-lg-3 col-md-4 col-6">
                <div className="footer-box">
                  <a className="navbar-brand logo" href="/" style={logo}>
                    <span className="logo-home" />APOL<span style={logoText}>LO</span>
                  </a>
                  <p>A modern, technology-first bank built for you and your growing business.</p>
                  <div className="social-link d-flex align-items-center">
                    <a href="/#"><FacebookIcon></FacebookIcon></a>
                    <a href="/#"><TwitterIcon></TwitterIcon></a>
                    <a href="/#"><LinkedInIcon></LinkedInIcon></a>
                    <a href="/#"><InstagramIcon></InstagramIcon></a>
                  </div>
                </div>
              </div>
              <div className="col-xl-2 col-lg-2 col-6">
                <div className="footer-box">
                  <h5>Company</h5>
                  <ul className="footer-link">
                    <li><a href="/#">About Us</a></li>
                    <li><a href="/#">Awards</a></li>
                    <li><a href="/#">Careers</a></li>
                  </ul>
                </div>
              </div>
              <div className="col-xl-2 col-lg-2 col-6">
                <div className="footer-box">
                  <h5>Useful Links</h5>
                  <ul className="footer-link">
                    <li><a href="signin.html">Products</a></li>
                    <li><a href="/#">Custommer</a></li>
                    <li><a href="/#">Merchant</a></li>
                  </ul>
                </div>
              </div>
              <div className="col-xl-2 col-lg-2 col-6">
                <div className="footer-box">
                  <h5>Support</h5>
                  <ul className="footer-link">
                    <li><a href="mailto:support@openwaygroup.com">Support@openwaygroup</a></li>
                    <li><a className="scrollToContact" href="/">Contact Us</a></li>
                    <li><a href="#faq">FAQ</a></li>
                  </ul>
                </div>
              </div>
              <div className="col-xl-3 col-8">
                <div className="footer-box">
                  <h5>Subscribe</h5>
                  <form>
                    <div className="form-group">
                      <input type="text" placeholder="Enter Your Email address" />
                      <button className="cmn-btn">Subscribe</button>
                    </div>
                  </form>
                  <p>Get the latest updates via email. Any time you may unsubscribe</p>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <div className="footer-bottom">
                  <div className="left">
                    <p> Copyright © <a href="/">OpenWayGroup</a> | Designed by
                      <a href="/#">PIXELAXIS</a>
                    </p>
                  </div>
                  <div className="right">
                    <a href="/#" className="cus-bor">Privacy </a>
                    <a href="/#">Terms &amp; Condition </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="img-area">
            <img src="./assets/images/home/footer-Illu-left.png" className="left" alt="Images" />
            <img src="./assets/images/home/footer-Illu-right.png" className="right" alt="Images" />
          </div>
        </div>
        {/* Footer Area End */}
        {/*==================================================================*/}
    </div>

  );
};

export default Home;